<template>
  <page>
    <v-card>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.fromDate"
                  :label="labels.fromDate"
                  v-validate="'required|start_after_today'"
                  :data-vv-as="labels.fromDate"
                  data-vv-name="fromDate"
                  :error-messages="errors.collect('fromDate')"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker
                  v-model="form.toDate"
                  :label="labels.toDate"
                  v-validate="toDateValidation(form.fromDate)"
                  :data-vv-as="labels.toDate"
                  data-vv-name="toDate"
                  :error-messages="errors.collect('toDate')"
                  :min="this.form.fromDate"
                ></cal-picker>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  v-if="!selectAllBrnMode"
                  multiple
                  :label="labels.branch"
                  :items="branchList"
                  v-model="form.branch"
                  item-text="value"
                  item-value="code"
                  data-vv-name="branch"
                  :data-vv-as="labels.branch"
                  :error-messages="errors.collect('branch')"
                  v-validate="'required'"
                >
                  <v-list-tile slot="prepend-item" @click="toggleBranchAll">
                    <v-list-tile-action>
                      <v-icon :color="form.branch.length > 0 ? 'indigo darken-4' : ''">{{ branchPrependIcon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title
                      ><b><i>Select All</i></b></v-list-tile-title
                    >
                    <hr />
                    <v-divider slot="prepend-item" class="mt-2"></v-divider>
                    <v-divider slot="append-item" class="mb-2"></v-divider>
                  </v-list-tile>
                </v-autocomplete>
                <v-autocomplete
                  v-else
                  multiple
                  hide-selected
                  :label="labels.branch"
                  :items="selectAllBrnList"
                  v-model="form.allBrnSelected"
                  item-text="value"
                  item-value="code"
                  data-vv-name="allBrnSelected"
                  :data-vv-as="labels.branch"
                  :error-messages="errors.collect('allBrnSelected')"
                >
                  <v-list-tile slot="prepend-item" @click="toggleBranchAll">
                    <v-list-tile-action>
                      <v-icon :color="form.branch.length > 0 ? 'indigo darken-4' : ''">{{ branchPrependIcon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title
                      ><b><i>Un-select All</i></b></v-list-tile-title
                    >
                    <hr />
                    <v-divider slot="prepend-item" class="mt-2"></v-divider>
                    <v-divider slot="append-item" class="mb-2"></v-divider>
                  </v-list-tile>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  v-if="!selectAllDeptMode"
                  multiple
                  :label="labels.department"
                  :items="deptList"
                  v-model="form.department"
                  item-text="value"
                  item-value="code"
                  data-vv-name="department"
                  :data-vv-as="labels.department"
                  :error-messages="errors.collect('department')"
                  v-validate="'required'"
                >
                  <v-list-tile slot="prepend-item" @click="toggleDepartmentAll">
                    <v-list-tile-action>
                      <v-icon :color="form.department.length > 0 ? 'indigo darken-4' : ''">{{ departmentPrependIcon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title
                      ><b><i>Select All</i></b></v-list-tile-title
                    >
                    <hr />
                    <v-divider slot="prepend-item" class="mt-2"></v-divider>
                    <v-divider slot="append-item" class="mb-2"></v-divider>
                  </v-list-tile>
                </v-autocomplete>
                <v-autocomplete
                  v-else
                  hide-selected
                  multiple
                  :label="labels.allDeptSelected"
                  :items="selectAllDeptList"
                  v-model="form.allDeptSelected"
                  item-text="value"
                  item-value="code"
                  data-vv-name="allDeptSelected"
                  :data-vv-as="labels.allDeptSelected"
                  :error-messages="errors.collect('allDeptSelected')"
                >
                  <v-list-tile slot="prepend-item" @click="toggleDepartmentAll">
                    <v-list-tile-action>
                      <v-icon :color="form.department.length > 0 ? 'indigo darken-4' : ''">{{ departmentPrependIcon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title
                      ><b><i>Un-select All</i></b></v-list-tile-title
                    >
                    <hr />
                    <v-divider slot="prepend-item" class="mt-2"></v-divider>
                    <v-divider slot="append-item" class="mb-2"></v-divider>
                  </v-list-tile>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <!-- -->
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :label="labels.reportTypes"
                  :items="reportTypesList"
                  v-model="form.reportTypes"
                  item-text="value"
                  item-value="code"
                  data-vv-name="reportTypes"
                  :data-vv-as="labels.reportTypes"
                  :error-messages="errors.collect('reportTypes')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-checkbox color="primary" :label="labels.rptParam" v-model="form.rptParam"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 class="pt-3">
                <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{ labels.export }}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="form.format">
                  <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{ format.label }}</span>
                    <v-icon :color="format.color">{{ format.icon }}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import clone from 'clone'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
export default {
  data() {
    return {
      labels: {
        fromDate: 'From Date',
        toDate: ' To Date',
        branch: 'Branch',
        department: 'Department',
        allDeptSelected: 'Department',
        format: 'Export Format',
        export: 'Export to',
        reportTypes: 'Type of Reports',
        sendEmail: 'Send Output to Email',
        rptParam: 'Print report runtime parameters'
      },
      form: {
        fromDate: '',
        toDate: '',
        branch: '',
        allBrnSelected: '',
        department: '',
        allDeptSelected: '',
        reportTypes: '1',
        format: 'PDF',
        sendEmail: false,
        rptParam: true
      },
      branchList: [],
      selectAllBrnList: [{ code: 'allBrnSelected', value: 'All' }],
      deptList: [],
      selectAllDeptList: [{ code: 'allDeptSelected', value: 'All' }],
      reportTypesList: [
        { code: '1', value: 'Accounts Transaction List' },
        { code: '2', value: 'RI Accounts Transaction List' },
        { code: '3', value: 'Payments & Receipts' },
        { code: '4', value: 'Debit & Credit Notes (Adjustment) List' },
        { code: '5', value: 'Accounts Transaction List (Sort By Transaction Type & Document No.)' }
      ],
      menu: {},
      supportedFormat: [],
      submitting: false,
      selectAllBrnMode: undefined,
      selectAllDeptMode: undefined
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    usrId() {
      return this.$store.state.token.usrId
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    allBranchSelected() {
      return this.form.branch.length === this.branchList.length
    },
    someBranchSelected() {
      return this.form.branch.length > 0 && !this.allBranchSelected
    },
    allDepartmentSelected() {
      return this.form.department.length === this.deptList.length
    },
    someDepartmentSelected() {
      return this.form.department.length > 0 && !this.allDepartmentSelected
    },
    branchPrependIcon() {
      if (this.allBranchSelected) {
        return 'mdi-close-box'
      }
      if (this.someBranchSelected) {
        return 'mdi-minus-box'
      }
      return 'mdi-checkbox-blank-outline'
    },
    departmentPrependIcon() {
      if (this.allDepartmentSelected) {
        return 'mdi-close-box'
      }
      if (this.someDepartmentSelected) {
        return 'mdi-minus-box'
      }
      return 'mdi-checkbox-blank-outline'
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    },
    'form.allBrnSelected': function (newVal, oldVal) {
      const newValue = newVal.toString()
      const oldValue = oldVal.toString()
      if (oldValue === 'allBrnSelected' && newValue === '') {
        this.selectAllBrnMode = false
        this.form.department = []
      }
    },
    'form.allDeptSelected': function (newVal, oldVal) {
      const newValue = newVal.toString()
      const oldValue = oldVal.toString()
      if (oldValue === 'allDeptSelected' && newValue === '') {
        this.selectAllDeptMode = false
        this.form.department = []
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.acctTransaction
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
            if (this.menu) {
              this.doFetchBranch()
              this.doFetchDepartment()
              this.selectAllDeptMode = true
              this.selectAllBrnMode = true
            }
          }
        }
      } catch (err) {
        throw err
      }
    },
    async doFetchBranch() {
      const apiURI = this.menu.getBranchList
      if (apiURI) {
        this.loading = true
        try {
          const expand = { usrId: this.usrId }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.branchList = []
          if (data) {
            data.map((datamap) => {
              const convertList = {
                code: datamap.branch,
                value: datamap.brnDesc
              }
              this.branchList.push(convertList)
            })
          }
          this.form.branch = []
          const temp = this.branchList.slice()
          for (var i = 0; i < temp.length; i++) {
            this.form.branch.push(temp[i].code)
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetchDepartment() {
      const apiURI = this.menu.getDeptList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.deptList = []
          if (data) {
            data.map((datamap) => {
              const convertList = {
                code: datamap.dept,
                value: datamap.deptDesc
              }
              this.deptList.push(convertList)
            })
          }
          this.form.department = []
          const temp = this.deptList.slice()
          for (var i = 0; i < temp.length; i++) {
            this.form.department.push(temp[i].code)
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    toDateValidation(fromDate) {
      const result = 'required|start_after_today|from_to_date:' + fromDate
      return result
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let clonedForm = clone(this.form)
          let tempBranchText = ''
          let tempDepartmentText = ''
          if (this.selectAllBrnMode) {
            tempBranchText = 'allBrnSelected'
          } else {
            if (clonedForm.branch.length > 0) {
              for (var bi = 0; bi < clonedForm.branch.length; bi++) {
                if (bi !== clonedForm.branch.length - 1) {
                  tempBranchText += clonedForm.branch[bi] + ', '
                } else {
                  tempBranchText += clonedForm.branch[bi]
                }
              }
            }
          }
          if (this.selectAllDeptMode) {
            tempDepartmentText = 'allDeptSelected'
          } else {
            if (clonedForm.department.length > 0) {
              for (var di = 0; di < clonedForm.department.length; di++) {
                if (di !== clonedForm.department.length - 1) {
                  tempDepartmentText += clonedForm.department[di] + ', '
                } else {
                  tempDepartmentText += clonedForm.department[di]
                }
              }
            }
          }
          clonedForm.branch = tempBranchText
          clonedForm.department = tempDepartmentText
          await this.$http.post(apiURI, clonedForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    toggleBranchAll() {
      this.$nextTick(() => {
        this.selectAllBrnMode = !this.selectAllBrnMode
        if (this.selectAllBrnMode) {
          this.form.allBrnSelected = []
          this.form.allBrnSelected.push('allBrnSelected')
        } else {
          this.form.allBrnSelected = []
        }
        if (this.allBranchSelected) {
          this.form.branch = []
        } else {
          this.form.branch = []
          const temp = this.branchList.slice()
          for (var i = 0; i < temp.length; i++) {
            this.form.branch.push(temp[i].code)
          }
        }
      })
    },
    toggleDepartmentAll() {
      this.$nextTick(() => {
        this.selectAllDeptMode = !this.selectAllDeptMode
        if (this.selectAllDeptMode) {
          this.form.allDeptSelected = []
          this.form.allDeptSelected.push('allDeptSelected')
        } else {
          this.form.allDeptSelected = []
        }
        if (this.allDepartmentSelected) {
          this.form.department = []
        } else {
          this.form.department = []
          const temp = this.deptList.slice()
          for (var i = 0; i < temp.length; i++) {
            this.form.department.push(temp[i].code)
          }
        }
      })
    }
  },
  created() {
    this.doInit()
    this.form.allBrnSelected = []
    this.form.allBrnSelected.push('allBrnSelected')
    this.form.allDeptSelected = []
    this.form.allDeptSelected.push('allDeptSelected')

    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than the date of application.`
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          // if (isAfter(today, startDate)) return false
          // else return true
          return isAfter(tomorrow, startDate)
        } else return true
      }
    })
  },
  mixins: [MessageMixin]
}
</script>
